import * as React from 'react';

// COMPONENTS
import Button from '../../../components/Button';
import SafeHtml from '../../../components/SafeHtml';
import DownloadLink from '../../../components/DownloadLink';
import DisplayDateTime from '../../../components/DisplayDateTime';

// TYPES
import { FeedbackProgressViewTypes } from './FeedbackProgressModal';

const ReadActivity: React.FC<FeedbackProgressViewTypes> = ({ activity = {}, closeModal }) => {
	const { title, occurrence, description, attachments, creator } = activity;

	return (
		<article className="feed-article">
			<header>
				<h2 className="heading h4">{title}</h2>

				<time>
					<DisplayDateTime>{occurrence}</DisplayDateTime>
				</time>
			</header>

			<section>
				<h3 className="subheading">Logged By</h3>

				<p>{creator}</p>
			</section>

			<section>
				<h3 className="subheading">Description of action taken</h3>

				{description ? <SafeHtml>{description}</SafeHtml> : <p>None</p>}
			</section>

			<section>
				<h3 className="subheading">Attachments</h3>

				{attachments && attachments.length > 0 ? (
					<ul>
						{attachments.map((attachment, index) => (
							<li key={index}>
								<DownloadLink url={attachment.link} name={attachment.displayFileName} />
							</li>
						))}
					</ul>
				) : (
					<p>None</p>
				)}
			</section>

			<section className="actions">
				<Button className="btn-primary full-width" onClick={closeModal}>
					Close
				</Button>
			</section>
		</article>
	);
};

export default ReadActivity;
